import React from 'react';
import { graphql } from 'gatsby';
import LitStructuredText from './generic/LitStructuredText';
import LitImage from './images/LitImage';

const ModularHeaderImageHeadingParagraph = ({ data }) => {
  const { backgroundColor, header, headingImageParagraphContent } = data;
  return (
    <div
      className={`modular-header-image-heading-paragraph-content ${backgroundColor}`}
    >
      <LitStructuredText data={header} basic />
      <div className="modular-header-image-heading-paragraph-inner">
        {headingImageParagraphContent.map(
          ({ heading, body, featureImage, id }) => {
            return (
              <div className="header-image-heading-paragraph-content" key={id}>
                <div className="feature-image">
                  <LitImage image={featureImage} />
                </div>
                <LitStructuredText data={heading} basic />
                <LitStructuredText data={body} basic />
              </div>
            );
          },
        )}
      </div>
    </div>
  );
};

export default ModularHeaderImageHeadingParagraph;
export const fragment = graphql`
  fragment ModularHeaderImageHeadingParagraph on DatoCmsHeaderImageHeadingParagraph {
    internal {
      type
    }
    id
    header {
      value
    }
    backgroundColor
    headingImageParagraphContent {
      id
      backgroundColor
      heading {
        value
      }
      body {
        value
      }
      featureImage {
        gatsbyImageData
      }
    }
  }
`;
